import * as React from "react";

export const ProductSwatches = ({
  swatches,
  currentColor,
  currentSwatch,
  swatchType,
  showName = false,
}) => {

  return (
    <div className={"product__swatches-container flex gap-x-6"}>
      {showName && currentColor && (
        <span className={"b2 product__swatches-title"}>{currentColor}</span>
      )}

      <div className={"product__swatches"}>
        {currentSwatch && swatchType === 'colour' &&
          <div>
            <div className={"product__swatch"}>
              <div className={"product__swatch-container border border-[#54565A] rounded-full"}>
                <div
                  className={"product__swatch_color border-2 border-white active"}
                  style={{ backgroundColor: currentSwatch }}
                ></div>
              </div>
            </div>
          </div>
        }

        {currentSwatch && swatchType === 'image' &&
          <div className={"product__swatch"}>
            <div className={"product__swatch-container border border-[#54565A] rounded-full"}>
              <img
                className={"product__swatch_image"}
                src={currentSwatch}
              />
            </div>
          </div>
        }

        {swatches.map((swatch, id) => {
          if (swatch.color === currentSwatch) return;

          return (
            <a
              key={id}
              href={`${swatch.url}`}
              className={`${swatch.is_product && "border-b-2 border-[#54565A]"}`}
            >
              <div className={"product__swatch"}>
                {swatch.color ? (
                  <div className={"product__swatch-container"}>
                    <div
                      className={"product__swatch_color"}
                      style={{ backgroundColor: swatch.color }}
                    ></div>
                  </div>
                ) : (
                  swatch.image && (
                    <div className={"product__swatch-container border border-transparent"}>
                      <img
                        className={"product__swatch_image"}
                        src={swatch.image}
                      />
                    </div>
                  )
                )}
                {swatch.show_name && swatch.name && swatch.name}
              </div>
            </a>
          )
        })}
      </div>
    </div>
  );
};
